import { render, staticRenderFns } from "./chiase.vue?vue&type=template&id=72095cb7&scoped=true&"
import script from "./chiase.vue?vue&type=script&lang=js&"
export * from "./chiase.vue?vue&type=script&lang=js&"
import style0 from "./chiase.vue?vue&type=style&index=0&id=72095cb7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../usr/lib/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72095cb7",
  null
  
)

export default component.exports